import {
  Component, AfterViewInit, ViewChildren, ElementRef, QueryList
} from '@angular/core';

@Component({
  styleUrls: ['./imprint.component.scss'],
  templateUrl: './imprint.component.html'
})
export class PageImprintComponent {
  public currentYear: number = new Date().getFullYear();
}



// WEBPACK FOOTER //
// ./src/app/pages/imprint/imprint.component.ts